CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Control_IconMenu, },
], () => {

    let lightVerticalDiv = $("<div style='display:block;margin:10px;float:left;'></div>");
    let darkVerticalDiv = $("<div style='display:block;margin:10px;width:70px;float:left;' theme='dark'></div>");
    let lightHorizontalDiv = $("<div style='display:block;margin:10px;float:left;'></div>");
    let darkHorizontalDiv = $("<div style='display:block;margin:10px;float:left;' theme='dark'></div>");

    let outputDiv = $("<div style='font-size:36px;margin:10px;width:600px;float:left;'></div>");

    $("body").append(lightVerticalDiv);
    $("body").append(darkVerticalDiv);
    $("body").append(lightHorizontalDiv);
    $("body").append(darkHorizontalDiv);
    $("body").append(outputDiv);

    enum Group {
        Main = 0,
        Children = 1,
        Action = 2,
    }

    let groups: CDN.Controls.IconMenuTypes.ItemGroupOptions[] = [
        {
            name: "main",
            selectionMode: CDN.Controls.IconMenuTypes.SelectionMode.SingleOrNone,
            items: [
                { text: "Home", icon: { type: "material-symbol", symbol: "Home" }, afterSelectionAsync: async (selected) => { if (selected) outputDiv.text('Home'); }, },
                {
                    text: "Search Delayed", icon: {
                        type: "material-symbol",
                        symbol: "Search"
                    }, afterSelectionAsync: async (selected) => new Promise((resolve) => {
                        if (selected) {
                            setTimeout(() => {
                                outputDiv.text('Search');
                                resolve(0);
                            }, 2000);
                        } else resolve(0);
                    }),
                },
                {
                    text: "Disabled", icon: {
                        type: "material-symbol", 
                        symbol: "visibility_off",
                    }, afterSelectionAsync: async (selected) => { if (selected) outputDiv.text('You should not be able to see this!!!'); },
                    disabled: true,
                    disabledTitle: "This is a disabled item."
                },
                { text: "Settings <span style='white-space:nowrap'>(long text)</span>", icon: { type: "material-symbol", symbol: "Settings" }, afterSelectionAsync: async (selected) => { if (selected) outputDiv.text('Settings'); }, },
            ],
        },
        {
            name: "children",
            selectionMode: CDN.Controls.IconMenuTypes.SelectionMode.Multiple,
            items: [
                { text: "Toggle1", icon: { type: "material-symbol", symbol: "snowboarding" }, afterSelectionAsync: async (selected) => outputDiv.text('Toggle1 ' + (selected ? 'on' : 'off')), },
                { text: "Toggle2", icon: { type: "material-symbol", symbol: "wheelchair_pickup" }, afterSelectionAsync: async (selected) => outputDiv.text('Toggle2 ' + (selected ? 'on' : 'off')), },
                { text: "Toggle3", icon: { type: "material-symbol", symbol: "assist_walker" }, afterSelectionAsync: async (selected) => outputDiv.text('Toggle3 ' + (selected ? 'on' : 'off')), },
            ],
        },
        {
            name: "action",
            selectionMode: CDN.Controls.IconMenuTypes.SelectionMode.Button,
            items: [
                { text: "Logout", icon: { type: "material-symbol", symbol: "logout" }, afterSelectionAsync: async (selected) => outputDiv.text('Logout'), },
            ],
        },
    ];

    let lightVerticalMenu = new CDN.Controls.IconMenu(lightVerticalDiv.get(0), {
        direction: CDN.Controls.IconMenuTypes.Direction.Vertical,
        itemLayout: CDN.Controls.IconMenuTypes.Direction.Horizontal,
        groups: groups,
    });

    let darkVerticalMenu = new CDN.Controls.IconMenu(darkVerticalDiv.get(0), {
        direction: CDN.Controls.IconMenuTypes.Direction.Vertical,
        groups: groups,
    });

    let lightHorizontalMenu = new CDN.Controls.IconMenu(lightHorizontalDiv.get(0), {
        direction: CDN.Controls.IconMenuTypes.Direction.Horizontal,
        groups: groups,
    });

    let darkHorizontalMenu = new CDN.Controls.IconMenu(darkHorizontalDiv.get(0), {
        direction: CDN.Controls.IconMenuTypes.Direction.Horizontal,
        groups: groups,
    });

    //try {
    darkHorizontalMenu.selectAsync({
        group: Group.Main,
        item: 0
    });
    //} catch (err) {
    //    console.log(err);
    //}
    //lightVerticalMenu.select(1, 0);
    //lightVerticalMenu.select(1, 1);
    //darkVerticalMenu.select(1, 0);
    //darkVerticalMenu.select(1, 1);
    //lightHorizontalMenu.select(1, 0);
    //lightHorizontalMenu.select(1, 1);
    darkHorizontalMenu.selectAsync({
        group: Group.Children,
        item: 0
    });
    //darkHorizontalMenu.select(1, 1);
});